import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.scss";
import { axiosClient } from "../../utils/axiosClient";
import { KEY_ACCESS_TOKEN, setItem } from "../../utils/localStorageManager";
import { showToast } from "../../redux/slices/appConfigSlice";
import { TOAST_SUCESS } from "../../App";
import { useDispatch } from "react-redux";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const response = await axiosClient.post("/auth/login", {
        email,
        password,
      });
      // console.log(result);
      // console.log("token", response.result.accessToken);
      setItem(KEY_ACCESS_TOKEN, response.result.accessToken);
      navigate("/");
      dispatch(
        showToast({
          type: TOAST_SUCESS,
          message: "Login Successfully",
        })
      );
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="login">
      <div className="login-box">
        <h2 className="heading">Login</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            className="email"
            id="email"
            onChange={(e) => setEmail(e.target.value)}
          />

          <label htmlFor="password">Password</label>
          <input
            type="password"
            className="password"
            id="password"
            onChange={(e) => setPassword(e.target.value)}
          />

          <input type="submit" className="submit" />
        </form>
        <p className="subheading">
          Do not have an accoung ? <Link to="/signup">Sign Up</Link>{" "}
        </p>
      </div>
    </div>
  );
}

export default Login;
